<div #qrcElement [class]="cssClass"></div>